import React from 'react';

interface ReportsListProps {
  onSelectReport: (reportId: string) => void;
}

const HeartIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"/>
  </svg>
);

const ArrowRightIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="5" y1="12" x2="19" y2="12"/>
    <polyline points="12 5 19 12 12 19"/>
  </svg>
);

const AlertIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
    <line x1="12" y1="9" x2="12" y2="13"/>
    <line x1="12" y1="17" x2="12.01" y2="17"/>
  </svg>
);

const reports = [
  {
    id: 'disease-state',
    title: 'Stan choroby',
    description: 'Kompleksowa analiza stanu zdrowia na podstawie wypróżnień. Zawiera metryki, wykresy trendów i klasyfikację stanu (remisja/stabilny/zaostrzenie).',
    icon: <HeartIcon />,
    color: '#6B7FFF',
    gradient: 'linear-gradient(135deg, #6B7FFF 0%, #8B5CF6 100%)'
  },
  {
    id: 'flares',
    title: 'Raport zdrowia jelit',
    description: 'Monitor stanu jelit, wzorce przed pogorszeniem, wpływ leków oraz jakość danych. Cztery sekcje w jednym raporcie.',
    icon: <AlertIcon />,
    color: '#FF4444',
    gradient: 'linear-gradient(135deg, #FF4444 0%, #FF6666 100%)'
  }
  // Tutaj w przyszłości dodamy więcej raportów
];

export const ReportsList: React.FC<ReportsListProps> = ({ onSelectReport }) => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-4 md:px-6 md:py-6">
      {/* Header */}
      <div className="mb-6 md:mb-8">
        <h1 className="text-xl md:text-2xl font-bold text-gray-900 mb-2">
          Raporty
        </h1>
        <p className="text-sm text-gray-500 m-0">
          Wybierz raport, który chcesz wyświetlić
        </p>
      </div>
      
      {/* Lista raportów - 1 kolumna mobile, 2 tablet, 3 desktop */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4 lg:gap-6">
        {reports.map(report => (
          <button
            key={report.id}
            onClick={() => onSelectReport(report.id)}
            className="bg-white border border-gray-200 rounded-lg md:rounded-xl p-4 md:p-6 text-left transition-all duration-200 shadow-sm hover:shadow-md hover:border-[#6B7FFF] w-full min-h-[44px]"
          >
            {/* Ikona */}
            <div 
              className="w-10 h-10 md:w-12 md:h-12 rounded-xl flex items-center justify-center text-white mb-3 md:mb-4"
              style={{ background: report.gradient }}
            >
              {report.icon}
            </div>
            
            {/* Tytuł */}
            <h3 className="text-base md:text-lg font-semibold text-gray-900 mb-2">
              {report.title}
            </h3>
            
            {/* Opis */}
            <p className="text-sm text-gray-600 mb-4 line-clamp-3">
              {report.description}
            </p>
            
            {/* Przycisk */}
            <div 
              className="flex items-center gap-2 text-sm font-medium"
              style={{ color: report.color }}
            >
              <span>Otwórz raport</span>
              <ArrowRightIcon />
            </div>
          </button>
        ))}
      </div>
      
      {/* Informacja o przyszłych raportach */}
      {reports.length === 1 && (
        <div className="mt-6 md:mt-8 p-4 md:p-5 bg-gray-50 rounded-xl border border-gray-200 text-center">
          <p className="text-sm text-gray-500 m-0">
            Więcej raportów już wkrótce...
          </p>
        </div>
      )}
    </div>
  );
};
